module.exports = "/_next/static/images/contact-monotone-5e3f71830c3b97f7a7c7626da43bf7a7.svg";